import { render } from "./SubscriptionPackageList.vue?vue&type=template&id=0b91d5db&scoped=true"
import script from "./SubscriptionPackageList.vue?vue&type=script&lang=js"
export * from "./SubscriptionPackageList.vue?vue&type=script&lang=js"

import "./SubscriptionPackageList.vue?vue&type=style&index=0&id=0b91d5db&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b91d5db"]])

export default __exports__